import React from "react";
import { REVIEWS } from "../../data/site";
import { Star } from "lucide-react";

const initials = (name) =>
  name
    .replace(/&/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="relative py-20 sm:py-28 px-4 sm:px-6 lg:px-10 bg-[#FFF0F5]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-brand-pink text-white font-fredoka font-bold rounded-full px-4 py-1.5 border-4 border-slate-900 neo-shadow-sm rotate-[-2deg]">
            REAL AIRBNB REVIEWS
          </span>
          <h2 className="font-fredoka font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 text-slate-900">
            Hugs, high-fives, <span className="text-brand-pink">5 stars.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 items-start">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              data-testid={`review-${i}`}
              className="relative bg-white border-4 border-slate-900 rounded-3xl p-6 sm:p-8 neo-shadow"
              style={{ transform: i % 2 ? "rotate(0.5deg)" : "rotate(-0.5deg)" }}
            >
              <div className="flex items-center gap-4">
                <div
                  data-testid={`review-avatar-${i}`}
                  className="w-14 h-14 flex-shrink-0 rounded-full border-4 border-slate-900 grid place-items-center font-fredoka font-bold text-lg text-slate-900 neo-shadow-sm"
                  style={{ background: r.color }}
                >
                  {initials(r.name)}
                </div>
                <div>
                  <p className="font-fredoka font-bold text-lg text-slate-900 leading-tight">{r.name}</p>
                  <p className="font-quicksand text-sm text-slate-500">{r.tenure}</p>
                </div>
              </div>

              <div className="mt-4 flex flex-wrap items-center gap-2">
                <div className="flex gap-0.5">
                  {[...Array(r.rating)].map((_, j) => (
                    <Star key={j} size={16} className="fill-slate-900 text-slate-900" />
                  ))}
                </div>
                <span className="font-quicksand text-sm text-slate-500">
                  · {r.date} · {r.trip}
                </span>
              </div>

              <p className="mt-4 font-quicksand text-lg text-slate-800 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
